import React from 'react'

const Tag = ({tag}) => {
    
    return (
        <div className='tag'><div className='dot'></div>{tag}</div>
  );
};

export default Tag